var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataReport)?_c('div',[_c('Pivot',{key:'pivot_'+_vm.forceUpdate,attrs:{"report":_vm.dataReport,"toolbar":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }